/** Bu company üçün menyu/səhifə adı "Xidmətlər" göstərilir */
export const SERVICES_COMPANY_ID = 3

export function resolveCompanyId(profileResponse) {
  const data = profileResponse?.data ?? profileResponse
  if (!data) return null
  const id = data.company?.id ?? data.company_id
  if (id == null || id === "") return null
  const num = Number(id)
  return Number.isNaN(num) ? null : num
}

export function getOrdersMenuLabel(companyId) {
  return Number(companyId) === SERVICES_COMPANY_ID ? "Xidmətlər" : "Sifarişlər"
}

export function cacheCompanyId(companyId) {
  if (companyId != null && companyId !== "") {
    localStorage.setItem("companyId", String(companyId))
  }
}

export function getCachedCompanyId() {
  const raw = localStorage.getItem("companyId")
  if (raw == null || raw === "") return null
  const num = Number(raw)
  return Number.isNaN(num) ? null : num
}
